// extracted by mini-css-extract-plugin
export default {"addForm":"profile_addForm__y1VgC","formControl":"profile_formControl__x6Csq","list":"profile_list__56g5t","btnWrpper":"profile_btnWrpper__2v9ne"};